import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable, intercept, observe } from 'mobx'
import styled, { keyframes } from 'styled-components'
import { TweenMax } from 'gsap'
import LockWhiteIcon from '@/assets/images/icon-lock-white.svg'
import ReactQuill, { Quill } from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import DDAnnounceSponsor from '@/Components/CommandHost/Common/DDAnnounceSponsor'
import { vhToPx } from '@/utils'
import { responsiveDimension } from '../../utils'
import { isBoolean, isNumber } from 'lodash'
import PlayIcon from '@/assets/images/PlayPause/hc-play.png'
import PauseIcon from '@/assets/images/PlayPause/hc-pause.png'
import InfinityIcon from '@/assets/images/PlayPause/infinity.png'

@inject('PrePlayStore', 'CommandHostStore', 'GameStore', 'AutomationStore')
export default class AnnounceItemLoad extends Component {
  constructor(props) {
    super(props)
    FONT_SIZE = this.props.CommandHostStore.fontSize + 'vh'
    extendObservable(this, {
      promptRemove: false,
      quillHeader: null,
      quillMiddle: null,
      quillBottom: null,
    })

    //this.reference = `announceitemload-editor-${this.props.item.index}`
    this.reference = `announceitemload-editor-${this.props.item.id}`

    this.state = {
      sessionStarted: this.props.GameStore.isSessionStarted,
      isPPAnnoc: false,
      timerInSeconds: 0,
      isPlayPaused: false,
      pausedTime: null,
      allow_unlim: false,
      isInifiniteIcon: false,
      nextPlayItem: this.props.PrePlayStore.nextPlayItem,
    }

    this.destroySessionMode = intercept(
      this.props.GameStore,
      'sessionMode',
      change => {
        this.setState({ sessionStarted: change.newValue === 1 })
        return change
      }
    )

    this.disposeNextPlayItem = observe(
      this.props.PrePlayStore,
      'nextPlayItem',
      change => {
        this.setState({ nextPlayItem: change.newValue })
      }
    )
  }

  async handleEndAnnounceClick(refId) {
    let { PrePlayStore } = this.props

    /*
    if ('recording' === this.props.GameStore.executionType) {
      await _editorEvents.push({
        gameId: this.props.GameStore.gameId,
        playId: null,
        evt: 'delay',
        refId: refId,
        wait: 0,
        sequence: 0,
        isIncrementHeaderPlaySequence: false,
        isIncrementPlaySequence: false,
        isIncrementSequence: true,
        timestampWait: 0,
        isPreviousPlayEnded: true,
        isUseGlobalTimestampWait: true
      })


      await _editorEvents.push({
        gameId: this.props.GameStore.gameId,
        playId: this.props.item.id,
        evt: 'click',
        refId: refId,
        wait: 0,
        sequence: 0,
        isIncrementHeaderPlaySequence: false,
        isIncrementPlaySequence: false,
        isIncrementSequence: true,
        timestampWait: 0,
        isPreviousPlayEnded: false
      })

      if (PrePlayStore.nextPlayItem && PrePlayStore.nextPlayItem.id) {
        await _editorEvents.push({
          gameId: this.props.GameStore.gameId,
          playId: PrePlayStore.nextPlayItem.id,
          evt: 'click',
          refId: `go-button-${PrePlayStore.nextPlayItem.type}-${PrePlayStore.nextPlayItem.id}`,
          wait: 0,
          sequence: 0,
          isIncrementHeaderPlaySequence: false,
          isIncrementPlaySequence: false,
          isIncrementSequence: true,
          timestampWait: 0,
          isPreviousPlayEnded: true,
        })
      }
    }
*/

    this.props.AutomationStore.addEvent({
      evt: 'click',
      refId: refId,
      wait: 1,
      playId: this.props.item.id,
    })
    if (PrePlayStore.nextPlayItem && PrePlayStore.nextPlayItem.id) {
      this.props.AutomationStore.addEvent({
        evt: 'click',
        refId: `go-button-${PrePlayStore.nextPlayItem.type}-${PrePlayStore.nextPlayItem.id}`,
        wait: 1,
        playId: PrePlayStore.nextPlayItem.id,
        isPreviousPlayEnded: true,
      })
    }

    //await this.props.item.editorEvents = ('recording' === this.props.GameStore.executionType) ? _editorEvents : null
    this.props.endAnnouncement(this.props.item)
  }

  handleSelectedSponsor(val, isAutomatic) {
    if (!this.props.item.pmetadata) this.props.item.pmetadata = {}
    if (!this.props.item.pmetadata.public) this.props.item.pmetadata.public = {}

    if (isAutomatic === 'Undo') {
      this.props.item.pmetadata.public.isManualOverride = false
    } else {
      this.props.item.pmetadata.public.isManualOverride = true
    }

    this.props.item.sponsor = val
    this.props.item.sponsorExpanded = false
    if (!val) {
      this.sponsorEnable(0, false)
    }

    this.forceUpdate()
  }

  sponsorEnable(val, isExpanded) {
    if (val === 1) {
      const bottomEditorReadOnly = document.getElementsByClassName(
        `${this.reference}-bottom-readonly`
      )
      const bottomEditor = document.getElementsByClassName(
        `${this.reference}-bottom`
      )
      const bottomSponsor = document.getElementsByClassName(
        `${this.reference}-sponsor`
      )
      if (bottomEditorReadOnly && bottomEditor && bottomSponsor) {
        TweenMax.set(bottomEditorReadOnly, { display: 'none' })
        TweenMax.set(bottomEditor, { display: 'none' })
        TweenMax.set(bottomSponsor, { display: 'block' })
        this.props.item.sponsorExpanded = isExpanded
      }
    } else {
      const bottomEditorReadOnly = document.getElementsByClassName(
        `${this.reference}-bottom-readonly`
      )
      const bottomEditor = document.getElementsByClassName(
        `${this.reference}-bottom`
      )
      const bottomSponsor = document.getElementsByClassName(
        `${this.reference}-sponsor`
      )
      if (bottomEditorReadOnly && bottomEditor && bottomSponsor) {
        // TweenMax.set(bottomEditorReadOnly, { display: 'flex' })
        TweenMax.set(bottomEditor, { display: 'none' })
        // TweenMax.set(bottomSponsor, { display: 'none' })
      }
    }
  }

  toggleEditor(area, mode, editor, editorReadOnly) {
    if (mode === 'editing') {
      const e = document.getElementsByClassName(editor)
      const ero = document.getElementsByClassName(editorReadOnly)
      TweenMax.set(e, { display: 'block' })
      TweenMax.set(ero, { display: 'none' })
    } else {
      const e = document.getElementsByClassName(editor)
      const ero = document.getElementsByClassName(editorReadOnly)
      TweenMax.set(e, { display: 'none' })
      TweenMax.set(ero, { display: 'flex' })

      setTimeout(() => {
        if (area === 'header') {
          this.props.item.announcements[0].value = this.quillHeader.root.innerHTML
          ero[0].innerHTML = this.quillHeader.root.innerHTML
        }
        if (area === 'middle') {
          this.props.item.announcements[1].value = this.quillMiddle.root.innerHTML
          ero[0].innerHTML = this.quillMiddle.root.innerHTML
        }
        if (area === 'bottom') {
          this.props.item.announcements[2].value = this.quillBottom.root.innerHTML
          ero[0].innerHTML = this.quillBottom.root.innerHTML
        }
      }, 0)
    }
  }

  initValues() {
    const { item } = this.props
    this.quillHeader.root.innerHTML = this.props.item.announcements[0].value
    this.quillMiddle.root.innerHTML = this.props.item.announcements[1].value
    this.quillBottom.root.innerHTML = this.props.item.announcements[2].value
    const isGMAnnounce = this.isGmAnnouncement(this.props.item)
    let bottomValue = ''
    if (isGMAnnounce) {
      const videoInfo =
        item.announcements[2].value.match(/{[^{}]*}/) &&
        item.announcements[2].value.match(/{[^{}]*}/)[0]
      this.parsedVideoInfo = JSON.parse(videoInfo)
      bottomValue = item.announcements[2].value.replace(videoInfo, '')
    }
    document.getElementsByClassName(
      `${this.reference}-header-readonly`
    )[0].innerHTML = this.props.item.announcements[0].value
    document.getElementsByClassName(
      `${this.reference}-middle-readonly`
    )[0].innerHTML = this.props.item.announcements[1].value
    document.getElementsByClassName(
      `${this.reference}-bottom-readonly`
    )[0].innerHTML = this.props.item.announcements[2].value
  }

  isGmAnnouncement(item) {
    return item.subType && item.subType.includes('gm_announce')
  }

  gMAnnouncePlayTitle(item, index) {
    let title =
      item && item.subType && item.subType.includes('msg')
        ? 'MES VID'
        : 'GM MES'
    return title.split(' ')[index]
  }

  getPresetName(item) {
    const parser = new DOMParser()
    let videoInfo =
      item.announcements[2].value.match(/{[^{}]*}/) &&
      item.announcements[2].value.match(/{[^{}]*}/)[0]
    if (videoInfo) {
      this.parsedVideoInfo = JSON.parse(videoInfo)
      return this.parsedVideoInfo && this.parsedVideoInfo.name
    }
    return 'GM VIDEO MP4'
  }

  initTimer() {
    clearTimeout(this.failsafeTimeout)
    this.failsafeTimeout = null
    let { time_limit } = this.props.GameStore.sportType || {}
    time_limit = time_limit ? time_limit['message'] || {} : {}
    if (time_limit && +time_limit.allow_unlim === 1) {
      this.setState({ allow_unlim: true })
    }
    const {
      item: { pmetadata = {} },
    } = this.props

    let parsedMetadata = pmetadata
    if (typeof pmetadata === 'string' && pmetadata) {
      try {
        parsedMetadata = JSON.parse(pmetadata)
      } catch (e) {
        parsedMetadata = {}
      }
    }

    let duration = parsedMetadata.pausedTime
      ? parsedMetadata.pausedTime
      : this.getBaselineDurationSeconds()

    duration = !isNaN(duration) && duration !== null ? +duration : duration

    let isPlayPaused =
      parsedMetadata && isBoolean(parsedMetadata.isPlayPaused)
        ? parsedMetadata.isPlayPaused
        : this.state.isPlayPaused

    let serverTime = this.props.PrePlayStore.getServerTime()
    let timerInSeconds = 0
    if (duration !== 'unlimited' && !isNaN(duration)) {
      if (isPlayPaused) {
        timerInSeconds = duration
      } else if (parsedMetadata && parsedMetadata.playStartTime) {
        const elapsedMs = Math.max(
          0,
          serverTime - new Date(parsedMetadata.playStartTime)
        )
        const remainingFloat = Math.max(0, duration - elapsedMs / 1000)
        timerInSeconds = Math.ceil(remainingFloat)
      } else {
        timerInSeconds =
          this.state &&
          this.state.timerInSeconds !== undefined &&
          this.state.timerInSeconds !== null &&
          this.state.timerInSeconds > 0
            ? this.state.timerInSeconds
            : duration
      }
      timerInSeconds = timerInSeconds < 0 ? 0 : timerInSeconds
    } else {
      timerInSeconds = duration
    }

    this.setState(
      {
        timerInSeconds,
        isPlayPaused: isPlayPaused,
        isInifiniteIcon:
          !parsedMetadata ||
          !parsedMetadata.timerInput ||
          parsedMetadata.timerInput === 'unlimited'
            ? true
            : false,
      },
      () => {
        if (isPlayPaused) {
          if (this.interval) {
            clearInterval(this.interval)
            this.interval = null
          }
        } else {
          this.updateTimer()
        }
      }
    )
  }

  getBaselineDurationSeconds() {
    let { time_limit } = this.props.GameStore.sportType || {}
    time_limit = time_limit ? time_limit['message'] || {} : {}

    const {
      item: { pmetadata = {} },
    } = this.props

    let duration =
      pmetadata && pmetadata.timerInput
        ? pmetadata.timerInput
        : time_limit
        ? time_limit.default
        : null

    if (
      duration !== 'unlimited' &&
      !isNaN(duration) &&
      time_limit &&
      time_limit.unit === 'min'
    ) {
      duration = duration * 60
    }

    return !isNaN(duration) && duration !== null ? +duration : duration
  }

  updateTimer() {
    if (
      this.state.isPlayPaused ||
      this.state.isInifiniteIcon ||
      this.state.timerInSeconds === 0
    ) {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
      return
    }

    if (this.interval) {
      // Already running
      return
    }
    this.interval = setInterval(() => {
      if (
        this.state.sessionStarted &&
        !this.state.isPlayPaused &&
        !this.state.isInifiniteIcon
      ) {
        const play = this.props.item
        let parsedMetadata = play.pmetadata
        if (typeof parsedMetadata === 'string' && parsedMetadata) {
          try {
            parsedMetadata = JSON.parse(parsedMetadata)
          } catch (e) {
            parsedMetadata = {}
          }
        }
        parsedMetadata = parsedMetadata || {}

        const duration = this.getBaselineDurationSeconds()
        if (
          duration !== 'unlimited' &&
          !isNaN(duration) &&
          parsedMetadata.playStartTime
        ) {
          const serverTime = this.props.PrePlayStore.getServerTime()
          const elapsedMs = Math.max(
            0,
            serverTime - new Date(parsedMetadata.playStartTime)
          )
          const remainingFloat = Math.max(0, duration - elapsedMs / 1000)
          const displaySeconds = Math.ceil(remainingFloat)

          if (displaySeconds !== this.state.timerInSeconds) {
            this.setState({ timerInSeconds: displaySeconds }, () => {
              if (displaySeconds === 0) {
                clearInterval(this.interval)
                this.interval = null
                clearTimeout(this.failsafeTimeout)
                this.failsafeTimeout = null
                if (!this.props.PrePlayStore.nextPlayItem) {
                  this.setState({ isInifiniteIcon: true })
                }
              }
            })
          }
        }
      }
    }, 100)
  }

  async handlePauseUpdatePlay(playState) {
    if (this.props.item) {
      const { isPlayPaused, timerInSeconds } = this.state
      let play = JSON.parse(JSON.stringify(this.props.item))
      if (typeof play.pmetadata === 'string' && play.pmetadata) {
        try {
          play.pmetadata = JSON.parse(play.pmetadata)
        } catch (e) {
          play.pmetadata = {}
        }
      }
      play.pmetadata = play.pmetadata || {}
      if (playState === 'paused') {
        // save paused time to server if play is paused
        if (isPlayPaused) {
          play.pmetadata.pausedTime = timerInSeconds
          play.pmetadata.isPlayPaused = isPlayPaused
          play.pmetadata.playStartTime = ''
          this.props.GameStore.updatePlay(play)
        }
      } else {
        const baselineDuration = this.getBaselineDurationSeconds()
        const elapsed =
          baselineDuration && !isNaN(baselineDuration)
            ? baselineDuration - timerInSeconds
            : 0

        play.pmetadata.isPlayPaused = isPlayPaused
        play.pmetadata.playStartTime = new Date(
          this.props.PrePlayStore.getServerTime().getTime() - elapsed * 1000
        )
        play.pmetadata.pausedTime = ''
        this.props.GameStore.updatePlay(play)
      }
    }
  }

  formatTimerInput(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60

    // Using padStart to ensure 2 digits for seconds (e.g., 5:04)
    return `${minutes}:${seconds.toString().padStart(2, '0')}m`
  }

  handlePause = async () => {
    await this.setState(
      prevState => ({
        isPlayPaused: true,
        pausedTime: prevState.timerInSeconds,
      }),
      () => {
        clearInterval(this.interval)
      }
    )
    this.handlePauseUpdatePlay('paused')
  }

  handlePlay = () => {
    this.setState({ isPlayPaused: false }, () => {
      if (this.state.pausedTime !== null) {
        const remainingTime = this.state.pausedTime
        this.setState(
          { timerInSeconds: remainingTime, pausedTime: null },
          this.updateTimer
        )
      } else {
        this.updateTimer()
      }
      this.handlePauseUpdatePlay('played')
    })
  }

  componentWillUnmount() {
    this.destroySessionMode()
    clearInterval(this.interval)
    clearTimeout(this.failsafeTimeout)

    // PARK TIEMR ON UNMOUNT
    const currentPlay = this.props.PrePlayStore.currentPlayItem
    const isPlayStillActive =
      currentPlay &&
      currentPlay.id === this.props.item.id &&
      currentPlay.inProcess

    if (
      isPlayStillActive &&
      this.props.PrePlayStore.isMainOperator &&
      this.props.PrePlayStore.activeSessionsCount <= 1 &&
      !this.state.isPlayPaused
    ) {
      this.handlePause()
    }
  }

  componentDidMount() {
    try {
      let Font = Quill.import('formats/font')
      Font.whitelist = [
        'pamainlight',
        'pamainregular',
        'pamainbold',
        'pamainextrabold',
      ]
      Quill.register(Font, true)

      this.quillHeader = new Quill(`.${this.reference}-header`, {
        modules: {
          toolbar: false,
        },
        theme: 'snow',
      })

      this.quillMiddle = new Quill(`.${this.reference}-middle`, {
        modules: {
          toolbar: false,
        },
        theme: 'snow',
      })

      this.quillBottom = new Quill(`.${this.reference}-bottom`, {
        modules: {
          toolbar: false,
        },
        theme: 'snow',
      })

      this.initValues()
      this.initTimer()

      // old
      // if (this.props.item.sponsor && this.props.item.sponsor.id) {
      //   this.sponsorEnable(1, false)
      // } else {
      //   this.sponsorEnable(0, false)
      // }

      if (
        this.props.item.sponsor &&
        this.props.item.sponsor.sponsorCategory &&
        this.props.item.sponsor.sponsorItem &&
        this.props.item.sponsor.sponsorItem.brandId
      ) {
        this.sponsorEnable(1, false)
      } else {
        this.sponsorEnable(0, false)
      }
      if (
        this.props.item &&
        this.props.item.pmetadata &&
        this.props.item.pmetadata.public
      ) {
        const publicData = this.props.item.pmetadata.public
        this.setState({
          isPPAnnoc: publicData.isPPAnnoc,
        })
      }
    } catch (err) {
      console.error('Sportoco - HostCommand Error: ', err)
    }

    delete this.props.item.editorEvents
  }

  componentDidUpdate(prevProps, prevState) {
    const isPmetaDiff = this.props.item.pmetadata !== prevProps.item.pmetadata
    const isSessionStartedDiff =
      this.state.sessionStarted !== prevState.sessionStarted
    const isMainOperatorDiff =
      this.props.PrePlayStore.mainOperatorId !==
      prevProps.PrePlayStore.mainOperatorId

    if (isPmetaDiff || isSessionStartedDiff || isMainOperatorDiff) {
      this.initTimer()
    }
  }

  render() {
    let { item, index } = this.props
    if (!item) return null
    let required = true
    let locked = true
    const isGMAnnounce = this.isGmAnnouncement(item)
    const endText = isGMAnnounce
      ? this.gMAnnouncePlayTitle(item, 1).includes('VID')
        ? 'END GAME MASTER VIDEO'
        : 'END GAME MASTER MESSAGE'
      : 'END ANNOUNCEMENT'
    const presetName = isGMAnnounce ? this.getPresetName(item) : ''
    const {
      isPPAnnoc,
      timerInSeconds,
      isPlayPaused,
      isInifiniteIcon,
      sessionStarted,
      nextPlayItem,
    } = this.state
    const isEndPlayButtonHidden = !nextPlayItem ? true : false

    return (
      <Container zIndex={1000 - index}>
        <Wrapper>
          <Main>
            <PlayStatusWrapper />
            <PlayTypeDD>
              <PrePlaySequence
                backgroundColor={isGMAnnounce ? '#19d1bf' : '#231f20'}
                text={`${item.sequence}`}
              />
              {isGMAnnounce ? (
                <PrePlaySingle backgroundColor={'#19d1bf'}>
                  <span
                    style={{ whiteSpace: 'break-spaces' }}
                  >{`${this.gMAnnouncePlayTitle(item, 0)} `}</span>
                  <span
                    style={{
                      color: ['MES'].includes(this.gMAnnouncePlayTitle(item, 1))
                        ? '#C61818'
                        : '#fff',
                    }}
                  >{`${this.gMAnnouncePlayTitle(item, 1)}`}</span>
                </PrePlaySingle>
              ) : (
                <PrePlaySingle
                  text={`${
                    item.type.toLowerCase() === 'announce' ? 'anoc' : item.type
                  }`}
                  backgroundColor={'#231f20'}
                >
                  {isPPAnnoc && (
                    <TextButton
                      name="pp"
                      color={'#fff'}
                      backgroundColor={'#10bc1c'}
                      width={1.7}
                      height={1.2}
                    >
                      {'PP'}
                    </TextButton>
                  )}
                </PrePlaySingle>
              )}
            </PlayTypeDD>
            <InputsWrapper>
              <Row>
                {isGMAnnounce && (
                  <SelectTypeLocked title={presetName}>
                    {presetName}
                  </SelectTypeLocked>
                )}
                <RowArea width={'35%'} key={0}>
                  <EditorReadOnly
                    locked
                    className={`${this.reference}-header-readonly`}
                    onClick={
                      locked
                        ? null
                        : this.toggleEditor.bind(
                            this,
                            'header',
                            'editing',
                            `${this.reference}-header`,
                            `${this.reference}-header-readonly`
                          )
                    }
                    isLineHeight={true}
                  />
                  <Editor
                    id="announce-editor"
                    className={`${this.reference}-header`}
                    onBlur={this.toggleEditor.bind(
                      this,
                      'header',
                      'locking',
                      `${this.reference}-header`,
                      `${this.reference}-header-readonly`
                    )}
                  />
                </RowArea>

                <RowArea width={'35%'} key={1}>
                  <EditorReadOnly
                    locked
                    className={`${this.reference}-middle-readonly`}
                    onClick={
                      locked
                        ? null
                        : this.toggleEditor.bind(
                            this,
                            'middle',
                            'editing',
                            `${this.reference}-middle`,
                            `${this.reference}-middle-readonly`
                          )
                    }
                    isLineHeight={true}
                    mLeft={0.2}
                  />
                  <Editor
                    id="announce-editor"
                    className={`${this.reference}-middle`}
                    onBlur={this.toggleEditor.bind(
                      this,
                      'middle',
                      'locking',
                      `${this.reference}-middle`,
                      `${this.reference}-middle-readonly`
                    )}
                  />
                </RowArea>

                <RowArea width={'20%'} key={2}>
                  <EditorReadOnly
                    locked
                    className={`${this.reference}-bottom-readonly`}
                    onClick={
                      locked
                        ? null
                        : this.toggleEditor.bind(
                            this,
                            'bottom',
                            'editing',
                            `${this.reference}-bottom`,
                            `${this.reference}-bottom-readonly`
                          )
                    }
                    style={{
                      display: 'none',
                    }}
                    mLeft={0.2}
                  />
                  <Editor
                    id="announce-editor"
                    className={`${this.reference}-bottom`}
                    onBlur={this.toggleEditor.bind(
                      this,
                      'bottom',
                      'locking',
                      `${this.reference}-bottom`,
                      `${this.reference}-bottom-readonly`
                    )}
                    style={{
                      display: 'none',
                    }}
                  />
                  <DDSponsorWrapper
                    className={`${this.reference}-sponsor`}
                    style={{
                      display: 'block',
                      marginLeft: '0.2vh',
                    }}
                  >
                    <DDAnnounceSponsor
                      locked
                      height={h}
                      index={`${this.reference}-sponsor`}
                      selectedSponsor={item.sponsor}
                      value={this.handleSelectedSponsor.bind(this)}
                      expanded={item.sponsorExpanded}
                      subType={item ? item.subType : null}
                      sponsorId={item.sponsorId}
                      sponsorMetaData={
                        item.sponsor ? item.sponsor.sponsorItem || null : null
                      }
                      pmetadata={
                        item.pmetadata ? item.pmetadata.public || null : null
                      }
                    />
                  </DDSponsorWrapper>
                </RowArea>
                <PIPAutoLockIn color={'#000'}>
                  <PIPAutoLockInTimer
                    backgroundColor={'#000'}
                    width={timerInSeconds > 60 ? '5.3' : '5'}
                    size={timerInSeconds > 60 ? '1.8' : '2.3'}
                  >
                    {isInifiniteIcon ? (
                      <InfinityIconCont src={InfinityIcon} />
                    ) : (
                      `${
                        timerInSeconds >= 0
                          ? timerInSeconds <= 60
                            ? timerInSeconds + 's'
                            : this.formatTimerInput(timerInSeconds)
                          : '0s'
                      }`
                    )}
                  </PIPAutoLockInTimer>
                </PIPAutoLockIn>
                <TimerControl locked={!sessionStarted || isEndPlayButtonHidden}>
                  {isInifiniteIcon || isPlayPaused ? (
                    <PlayIconCont
                      src={PlayIcon}
                      onClick={e => {
                        e.stopPropagation()
                        if (!isInifiniteIcon && sessionStarted)
                          this.handlePlay()
                      }}
                      allow_unlim={isInifiniteIcon}
                    />
                  ) : (
                    <PauseIconCont
                      src={PauseIcon}
                      onClick={e => {
                        e.stopPropagation()
                        if (!isInifiniteIcon) this.handlePause()
                      }}
                      allow_unlim={isInifiniteIcon}
                    />
                  )}
                  <span style={{ display: 'none' }}>
                    {this.props.PrePlayStore.mainOperatorId}
                  </span>
                </TimerControl>
              </Row>
            </InputsWrapper>
            <LastButtonWrapper>
              <EndAnnounceButton
                locked={!sessionStarted}
                id={`end-button-Announce-${item.id}`}
                text={
                  isGMAnnounce
                    ? this.gMAnnouncePlayTitle(item, 1).includes('VID')
                      ? 'END GM MESSAGE'
                      : 'END GM VIDEO'
                    : 'END ANNOUNCEMENT'
                }
                onClick={
                  !sessionStarted
                    ? null
                    : this.handleEndAnnounceClick.bind(
                        this,
                        `end-button-Announce-${item.id}`
                      )
                }
              />
            </LastButtonWrapper>
          </Main>
        </Wrapper>
      </Container>
    )
  }
}

const h = 6
let FONT_SIZE = '1.8vh'

const Container = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  opacity: 0;
  animation: ${props => fadeIn} 0.3s forwards;
  margin-top: ${props => 0.1}vh;
  margin-bottom: ${props => 0.1}vh;
  z-index: ${props => props.zIndex};
`

const fadeIn = keyframes`
  0%{opacity: 0;}
  100%{opacity: 1}
`

const Wrapper = styled.div`
  width: inherit;
  height: inherit;
  margin-top: ${props => 0.1}vh;
  margin-bottom: ${props => 0.1}vh;
  padding: ${props => 1.5}vh 0 ${props => 1.5}vh 0;
`

const Main = styled.div`
  width: inherit;
  height: ${props => h}vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
`

const PlayTypeDD = styled.div`
  width: 9%;
  height: ${props => h}vh;
  display: flex;
`
const PlayStatusWrapper = styled.div`
  width: 3.2%;
  height: ${props => h}vh;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url(${LockWhiteIcon});
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
`

const PrePlaySequence = styled.div`
  width: 40%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainlight;
  font-size: ${props => FONT_SIZE};
  color: white;
  line-height: 1;
  border-right: 0.5px solid;
  &:after {
    content: '${props => props.text}';
  }
`

const PrePlaySingle = styled.div`
  width: 60%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: white;
  line-height: 1;
  text-transform: uppercase;
  &:after {
    content: '${props => props.text}';
  }
`

const TextButton = styled.div`
  position: absolute;
  left: 9.9%;
  top: 25.4%;
  padding-top: 0.1%;
  width: ${props => responsiveDimension(props.width || 2)};
  height: ${props => responsiveDimension(props.height || 2)};
  color: ${props => props.color || '#fff'};
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainregular;
  font-size: ${props => responsiveDimension(0.7)};
  border: ${responsiveDimension(0.2)} solid #000;
`

const SelectTypeLocked = styled.div`
  width: auto;
  max-width: calc(50ch + 1vh);
  flex-shrink: 0;
  height: ${props => h}vh;
  background-color: #e5e5e5;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: #000000;
  text-transform: uppercase;
  display: block;
  text-align: center;
  line-height: ${props => h}vh;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.5vh;
`

const InputsWrapper = styled.div`
  width: 87.6%;
  height: ${props => h}vh;
`

const Row = styled.div`
  width: 100%;
  height: inherit;
  display: flex;
  flex-direction: row;
`

const RowArea = styled.div`
  width: ${props => props.width || '100%'};
  height: inherit;
  display: flex;
  flex-direction: row;
`

const Editor = styled.div`
  width: 100%;
  height: inherit;
  background-color: #ffffff;
  display: none;
`

const EditorReadOnly = styled.div`
  width: 100%;
  height: inherit;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  // text-indent: ${props => 2}vh;
  padding-left: 1vh;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  margin-left: ${props => props.mLeft || ''}vh;
  text-transform: uppercase;
  font-family: ${props => (props.isGMAnnounce ? 'pamainbold' : 'pamainlight')};
  line-height: ${props => props.isLineHeight && 1.6};
  overflow: auto;
  ms-overflow-style: ${'-ms-autohiding-scrollbar'};
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0.3vh rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
    border-radius: ${props => 1}vh;
  }
  &::-webkit-scrollbar {
    width: ${props => responsiveDimension(0.4)};
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 0, 0, 0.6);
    &:hover {
      background-color: rgba(255, 0, 0, 1);
    }
    border-radius: ${props => 1}vh;
  }

  p {
    margin: auto 0;
  }
`

const LastButtonWrapper = styled.div`
  width: 10.2%;
  height: inherit;
  display: flex;
`

const EndAnnounceButton = styled.div`
  width: 100%;
  height: 100%;
  background-color: #c61818;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 1vh;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  filter: grayscale(${props => (props.locked ? 1 : 0)});
  &:after {
    content: '${props => (props.text ? props.text : 'END ANNOUNCEMENT')}';
    color: #ffffff;
  }
`

const DDSponsorWrapper = styled.div`
  width: 100%;
  position: relative;
  display: none;
`

const PIPAutoLockIn = styled.div`
  width: 5%;
  height: inherit;
  color: ${props => props.color || '#c61818'};
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  opacity: ${props => (props.isStarted ? 0.2 : 1)};
`

const PIPAutoLockInTimer = styled.div`
  width: ${props => props.width || 5}vh;
  height: ${props => 5}vh;
  border-top-left-radius: ${props => 5}vh;
  border-bottom-left-radius: ${props => 5}vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  font-family: pamainregular;
  font-size: ${props => props.size || 2.3}vh;
  color: #ffffff;
  background-color: ${props => props.backgroundColor || '#c61818'};
`

const TimerControl = styled.div`
  display: flex;
  position: relative;
  width: 5%;
  height: inherit;
  background-color: transparent;
  justify-content: center;
  align-items: center;
  visibility: ${props => (props.locked ? 'hidden' : 'visible')};
`

const PlayIconCont = styled.img`
  width: 40%;
  cursor: ${props => (props.allow_unlim ? '' : 'pointer')};
`
const PauseIconCont = styled.img`
  width: 40%;
  cursor: ${props => (props.allow_unlim ? '' : 'pointer')};
`

const InfinityIconCont = styled.img`
  position: absolute;
  width: 25px;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 4px;
  z-index: 6;
`



// WEBPACK FOOTER //
// src/Components/CommandHost/AnnounceItemLoad.js